import apiClient from "./apiClient";
import { normalizeApiError } from "../utils/apiError";

function toArray(value) {
  return Array.isArray(value) ? value : [];
}

function extractData(payload) {
  return payload?.data ?? payload;
}

const blService = {
  async getBLDetails(params = {}) {
    try {
      // Remove empty values to avoid sending unusable filters.
      const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {});

      const response = await apiClient.get("/bl-master", {
        params: cleanParams,
      });

      const payload = response?.data || {};
      const dataRoot = extractData(payload);
      const items = toArray(dataRoot?.data || dataRoot?.items || dataRoot);
      const meta = dataRoot?.meta || payload?.meta || {};

      return {
        items,
        meta: {
          page: Number(meta?.page || cleanParams.page || 1),
          limit: Number(meta?.limit || cleanParams.limit || 10),
          total: Number(meta?.total || meta?.totalItems || items.length || 0),
          totalPages: Number(meta?.totalPages || 1),
        },
        raw: payload,
      };
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getBLDetailById(id) {
    if (!id) throw new Error("BL ID is required");

    try {
      const response = await apiClient.get(`/bl-master/${id}`);
      const payload = response?.data || {};
      return extractData(payload);
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getBLByNumber(blNo) {
    if (!blNo) throw new Error("BL Number is required");

    try {
      const response = await apiClient.get(`/bl-master/bl-number/${encodeURIComponent(blNo)}`);
      const payload = response?.data || {};
      return extractData(payload);
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async createBLDetail(blData) {
    try {
      const response = await apiClient.post("/bl-master", blData);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async updateBLDetail(id, blData) {
    if (!id) throw new Error("BL ID is required");

    try {
      const response = await apiClient.patch(`/bl-master/${id}`, blData);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async deleteBLDetail(id) {
    if (!id) throw new Error("BL ID is required");

    try {
      const response = await apiClient.delete(`/bl-master/${id}`);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getActiveBLs(params = {}) {
    try {
      const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {});

      const response = await apiClient.get("/bl-master/active", {
        params: cleanParams,
      });

      const payload = response?.data || {};
      const dataRoot = extractData(payload);
      const items = toArray(dataRoot?.data || dataRoot?.items || dataRoot);

      return {
        items,
        raw: payload,
      };
    } catch (error) {
      throw normalizeApiError(error);
    }
  },
};

export default blService;
